import { Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { ProductInterest } from '../../interfaces/lead-form/product-interest';

@Injectable({
  providedIn: 'root'
})
export class LeadFormGchToTableDataMapperService {

  constructor() { }

  public map(productInterest: ProductInterest): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'YOURNOTES',
        value: productInterest.notes,
        valueWrap: true,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CAMPAIGNCODE',
        value: productInterest.campaignCode,
        valueWrap: true,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CONTRACTCHANNEL',
        i18nValueKey: productInterest.contractChannel,
        valueWrap: true,
      },
    ];
  }

}
